import "../../js/core";
import "./page-home-2025.scss";
import "../../../assets/src/eos/js/video-youtube-iframe";
import setBlogSubscribeModalHandlers from "../../../assets/src/eos/js/modals/setBlogSubscribeModalHandlers";
import "../../components/site-elements/other-blocks/vertical-tabs/vertical-tabs";

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".slider-stories").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
          1241: {
            items: 4,
            margin: 35,
          },
        },
        loop: false,
        nav: true,
        dots: true,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-membership").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          568: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1241: {
            items: 4,
          },
          1441: {
            items: 5,
          },
        },
        nav: true,
        dots: false,
        dotsEach: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-mob-card-industries").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          768: {
            items: 3,
          },
          992: {
            items: 4,
          },
          1241: {
            items: 0,
            dots: false,
            nav: false,
            dotsEach: false,
            margin: 0,
          },
        },
        slideBy: 1,
        dots: false,
        nav: true,
        loop: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-mob-card-partners").owlCarousel({
        responsive: {
          0: {
            items: 2,
          },
          480: {
            items: 3,
          },
          640: {
            items: 4,
          },
          900: {
            items: 5,
          },
          1241: {
            items: 6,
          },
          1441: {
            items: 0,
            dots: false,
            nav: false,
            dotsEach: false,
            margin: 0,
          },
        },
        slideBy: 1,
        dots: false,
        nav: true,
        loop: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(function () {
        $(window)
          .on("resize", function () {
            const width = $(window).width();

            if (width <= 1241) {
              $(".slider-mob-card-industries").addClass("owl-carousel");
            } else {
              $(".slider-mob-card-industries").removeClass("owl-carousel");
            }

            if (width <= 1440) {
              $(".slider-mob-card-partners").addClass("owl-carousel");
            } else {
              $(".slider-mob-card-partners").removeClass("owl-carousel");
            }

            const $products = $(".slider-mob-card-products");
            if (width <= 991) {
              if (!$products.hasClass("owl-loaded")) {
                $products.addClass("owl-carousel").owlCarousel({
                  responsive: {
                    0: { items: 1 },
                    768: { items: 2 },
                  },
                  slideBy: 1,
                  dots: false,
                  nav: true,
                  loop: false,
                  margin: 20,
                  smartSpeed: 200,
                });
                $products
                  .find(".owl-nav, .owl-dots")
                  .wrapAll("<div class='owl-controls'></div>");
              }
            } else {
              if ($products.hasClass("owl-loaded")) {
                $products
                  .trigger("destroy.owl.carousel")
                  .removeClass("owl-carousel owl-loaded");
                $products.find(".owl-stage-outer").children().unwrap();
                $products.find(".owl-controls").remove();
              }
            }
          })
          .trigger("resize");
      });

      const $testimonialSlider = $(".slider-testimonials");
      $testimonialSlider.owlCarousel({
        responsive: {
          0: { items: 1, dots: false },
          768: { items: 2, dots: true },
        },
        slideBy: 1,
        nav: true,
        loop: true,
        margin: 20,
        autoHeight: true,
        smartSpeed: 600,
      });

      $(".owl-carousel").each(function () {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });

      $(window)
        .on("resize", function () {
          const width = $(window).width();
          $(".slider-mob-card-industries").toggleClass(
            "owl-carousel",
            width <= 1241,
          );
          $(".slider-mob-card-partners").toggleClass(
            "owl-carousel",
            width <= 1440,
          );
        })
        .trigger("resize");

      $testimonialSlider.on("click", ".testimonial-body p", function (e) {
        if (
          $(e.target).closest(".js-data-testimonial, .js-video-play-btn").length
        )
          return;
        const $this = $(this);
        if ($this.hasClass("is-truncatable") || $this.hasClass("is-expanded")) {
          $this.toggleClass("is-expanded");
          $testimonialSlider.trigger("refresh.owl.carousel");
          setTimeout(() => {
            $testimonialSlider.trigger("refresh.owl.carousel");
          }, 600);
        }
      });

      function markTruncated() {
        $testimonialSlider.find(".testimonial-body p").each(function () {
          const $el = $(this);
          const maxHeight = parseFloat($el.css("max-height"));
          const fullHeight = this.scrollHeight;
          if (fullHeight > maxHeight + 2) {
            $el.addClass("is-truncatable").css("cursor", "pointer");
          } else if (!$el.hasClass("is-expanded")) {
            $el.removeClass("is-truncatable").css("cursor", "default");
          }
        });
      }

      $testimonialSlider.on(
        "translated.owl.carousel initialized.owl.carousel",
        markTruncated,
      );
      setTimeout(markTruncated, 800);
    });
  });

  $(document).on("click", ".js-video-play-btn", function (e) {
    e.preventDefault();
    const $wrap = $(this).closest(".js-testimonial-video-box");

    if (!$wrap.data("initial-html")) {
      $wrap.data("initial-html", $wrap.html());
    }

    const videoUrl = $wrap.data("video-url");
    const videoTitle = $wrap.data("video-alt");

    if (videoUrl) {
      $wrap.html(`
        <iframe allowfullscreen="" allow="autoplay" src="${videoUrl}" 
                class="video-media" title="${videoTitle}"></iframe>
      `);
    }
  });

  $(document).on("hidden.bs.modal", ".modal-testimonial", function () {
    const $wrap = $(this).find(".js-testimonial-video-box");
    const initialHtml = $wrap.data("initial-html");

    if (initialHtml) {
      $wrap.html(initialHtml);
    }
  });

  setBlogSubscribeModalHandlers("#modalSubscribeSent");
});
